import { Share as Share_kojaro } from './Share.kojaro';
import { Share as Share_phosphor } from './Share.phosphor';
import { Share as Share_zoomg } from './Share.zoomg';
import { Share as Share_zoomit } from './Share.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Share_kojaro;

    case 'zoomg':
      return Share_zoomg;

    case 'phosphor':
      return Share_phosphor;

    default:
      return Share_zoomit;
  }
};

export const Share = IconRenderer();
